import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Label,
  Icon,
} from 'semantic-ui-react';
import _ from 'lodash';
import Avatar from './../avatar';

const buttonStyle = {
  width: '100%',
};

const buildSignupLink = (name, email) => {
  const params = new URLSearchParams({ name, email });
  return `${window.location.origin}/signup?${params.toString()}`;
};

class TeamMember extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
    };
    this.handleCopyLink = this.handleCopyLink.bind(this);
  }

  handleCopyLink() {
    const { member } = this.props;
    const link = buildSignupLink(member.name, _.toLower(member.email));

    if (!navigator.clipboard || !navigator.clipboard.writeText) {
      console.error('Clipboard API not available');
      return;
    }

    navigator.clipboard.writeText(link)
      .then(() => {
        this.setState({ copied: true });
        clearTimeout(this.copiedTimeout);
        this.copiedTimeout = setTimeout(() => {
          this.setState({ copied: false });
        }, 1500);
      })
      .catch(err => {
        console.error('Failed to copy signup link', err);
      });
  }

  componentWillUnmount() {
    clearTimeout(this.copiedTimeout);
  }

  render() {
    const { props, state } = this;

    return (
      <Card color={props.member.isUserSuperAdmin ? 'green' : 'grey'}>
        <Card.Content>
          <Avatar
            name={props.member.name}
            noTooltip
            size={40}
          />
          <Card.Header>
            { props.member.name }
          </Card.Header>
          <Card.Meta>
            { _.toLower(props.member.email) }
          </Card.Meta>
          <Card.Description>
            {
              props.member.isUserSuperAdmin
                ? <Label basic color="green"><Icon name="user circle outline" />Super Admin</Label>
                : <Label basic color="grey"><Icon name="user circle outline" />Team Member</Label>
            }
          </Card.Description>
        </Card.Content>
        <Card.Content extra>
          <div className="ui buttons" style={buttonStyle}>
            <Button
              color={state.copied ? 'green' : 'blue'}
              icon={state.copied ? 'check' : 'linkify'}
              basic
              content={state.copied ? 'Copied!' : 'Copy signup link'}
              onClick={this.handleCopyLink}
            />
            <Button
              color={props.buttonColor}
              icon={props.buttonIcon}
              basic
              content={props.buttonLabel}
              id={props.member.id}
              name={props.member.name}
              onClick={props.buttonClickHandler}
            />
          </div>
        </Card.Content>
      </Card>
    );
  }
}

TeamMember.propTypes = {
  member: PropTypes.object.isRequired,
  buttonClickHandler: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
  buttonColor: PropTypes.string,
  buttonIcon: PropTypes.string,
};

TeamMember.defaultProps = {
  buttonLabel: 'delete',
  buttonColor: 'red',
  buttonIcon: 'delete',
};

export default TeamMember;



/** WEBPACK FOOTER **
 ** ./src/components/team-member/index.js
 **/